<script setup lang="ts">
definePageMeta({ middleware: 'guest' })

const email = ref('')
const busy = ref(false)
const sent = ref(false)
const error = ref<string | null>(null)

async function submit(): Promise<void> {
    busy.value = true
    error.value = null

    try {
        await $fetch('/api/auth/forgot-password', { method: 'POST', body: { email: email.value } })
        sent.value = true
    } catch {
        error.value = 'Gagal menghantar pautan. Cuba lagi.'
    } finally {
        busy.value = false
    }
}
</script>

<template>
    <div class="mx-auto max-w-md py-8">
        <div class="card !p-6">
            <p class="kicker">Akaun</p>
            <h1 class="mt-1 text-3xl font-bold tracking-tight">Lupa kata laluan</h1>
            <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
                Masukkan emel anda. Kami akan hantar pautan reset.
            </p>

            <div v-if="sent" class="notice mt-6 font-bold" role="status">
                ✓ Jika emel anda wujud dalam sistem, pautan reset telah dihantar. Semak inbox!
            </div>

            <form v-else class="mt-6 space-y-4" @submit.prevent="submit">
                <div>
                    <label class="label" for="email">Emel</label>
                    <input
                        id="email"
                        v-model="email"
                        type="email"
                        class="input"
                        required
                        autocomplete="email"
                    >
                </div>

                <p v-if="error" class="notice notice-danger" role="alert">{{ error }}</p>

                <button type="submit" class="btn-primary w-full" :disabled="busy">
                    {{ busy ? 'Menghantar…' : 'Hantar pautan reset' }}
                </button>
            </form>

            <p class="mt-5 text-sm">
                <NuxtLink
                    to="/auth/login"
                    class="font-medium text-brand-600 hover:underline dark:text-brand-400"
                    >← Kembali ke log masuk</NuxtLink
                >
            </p>
        </div>
    </div>
</template>
